import { SelectOption } from '@/components/elements/select'
import { UsersPositions } from '@/entities/api/users/users'

export const filtersMapUserPositions = [
    { name: 'Administración', value: UsersPositions.administration },
    { name: 'Soporte', value: UsersPositions.support_manager },
    { name: 'Inventario', value: UsersPositions.stock_manager } 
]

export const PositionsMap: SelectOption[] = [
    { label: 'Administración', value: UsersPositions.administration },
    { label: 'Soporte', value: UsersPositions.support_manager },
    { label: 'Inventario', value: UsersPositions.stock_manager } 
]
